import { useState, useEffect } from "react";
import { fieldType, FormValuesAddCard } from "../../../../../types/form";
import Form from "../../../../../components/Form";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems, selectGetStatus } from "src/modules/spItems/selectors";
import { getItems } from "src/modules/spItems/actions";
import _ from "lodash";
import moment from "moment";
import { selectCurrentUser } from "src/modules/users/selector";
import {
  collectionsListName,
  departmentsListName,
  dependenciesListName,
  documentCodeIndexesListName,
  equipmentsListName,
  linesListName,
  MDWorkstationListName,
  processesListName,
  sectorsListName,
  typesListName,
} from "src/api/config";
import { getItemsRequest } from "src/modules/spItems/api";

type Props = {
  setFormData: (obj: FormValuesAddCard) => void;
  openCancelAddCard: boolean;
  setOpenCancelAddCard: (b: boolean) => void;
  defaultValues: any;
  setIndexDocument: any;
  setIndexDocumentNumber: any;
  indexDocument: string;
};

function Step_2(props: Props) {
  const {
    setFormData,
    openCancelAddCard,
    setOpenCancelAddCard,
    defaultValues,
    setIndexDocument,
    setIndexDocumentNumber,
    indexDocument,
  } = props;
  const [dependenceFields, setDependenceFields] = useState<any>({
    Collection: null,
    Department: null,
    Process: null,
    Sector: null,
    Type: null,
  });
  const [code, setCode] = useState("__.__.__.__.__");
  const [fieldsForm, setFieldsForm] = useState<fieldType[]>([
    {
      type: "file",
      key: "File",
      require: true,
      width: "w-full",
      title: "Перетащите документ сюда или",
      titleFile: "выберите файл",
      placeholder:
        "Размер файла не более 50MB. Eсли это видео, то не более 200MB",
    },
    {
      type: "input",
      key: "Title",
      require: true,
      title: "Название",
      placeholder: "Введите название",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      key: "DocType",
      title: "Тип документа, соответствующий шаблону",
      placeholder: "Выберите из списка",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      key: "Collection",
      title: "Коллекция",
      placeholder: "Выберите из списка",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      title: "Подразделение/Функция",
      key: "Department",
      placeholder: "Не выбрано",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      title: "Колонна/Направление/Отдел ",
      key: "Sector",
      placeholder: "Выберите из списка",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: true,
      key: "Process",
      title: "Блок колонны/Участок",
      placeholder: "Не выбрано",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "select",
      require: false,
      multiple: true,
      title: "Рабочее место",
      key: "WorkPlaces",
      placeholder: "Выберите из списка",
      width: "w-full",
    },
    {
      type: "select",
      require: true,
      title: "Критичность",
      key: "Critical",
      placeholder: "Выберите из списка",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: true,
      single: true,
      key: "ResponsibleForRevision",
      title: "Ответственный за пересмотр",
      current: true,
      placeholder: "Введите имя или фамилию",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "date",
      require: true,
      default: {
        startDate: moment(new Date()).add(3, "years").toDate(),
        endDate: moment(new Date()).add(3, "years").toDate(),
      },
      key: "DateForRevision",
      title: "Срок пересмотра",
      placeholder: "Выберите дату",
      width: "w-[calc(50%-10px)]",
    },
    {
      type: "repeater",
      key: equipmentsListName,
      title: "Оборудование",
      fields: [
        {
          type: "autocomplete",
          require: false,
          title: "SAP № технического места",
          key: "SAP",
          placeholder: "Начните вводить SAP",
          width: "w-[calc(50%-10px)]",
          searchApiField: "SAP",
          searchApiList: equipmentsListName,
          searchApiSelectFields:
            "ID,Title,SAP,Manufacturer,Model,TypeEquipment",
          searchApiFilterField: "",
          searchApiFilterFieldValue: "",
        },
        {
          type: "select",
          require: false,
          key: "Line",
          title: "Линия розлива",
          placeholder: "Выберите из списка",
          width: "w-[calc(50%-10px)]",
        },
        {
          type: "text",
          title: "Название оборудования",
          key: "Title",
          value: "",
          require: false,
          width: "w-full",
        },
        {
          type: "text",
          title: "Производитель оборудования",
          key: "Manufacturer",
          value: "",
          require: false,
          width: "w-full",
        },
        {
          type: "text",
          title: "Модель оборудования",
          key: "Model",
          value: "",
          require: false,
          width: "w-full",
        },
        {
          type: "text",
          title: "Тип оборудования",
          key: "TypeEquipment",
          value: "",
          require: false,
          width: "w-full",
        },
      ],
      width: "w-full",
      require: false,
    },
    {
      type: "input",
      require: false,
      key: "Code",
      disabled: true,
      title: "Кодировка документа",
      placeholder: "",
      width: "w-full",
    },
    {
      type: "input",
      require: false,
      disabled: true,
      title: "Папка",
      key: "Path",
      placeholder:
        "Коллекция/Подразделение.Функция/Колонна.Направление.Отдел/Блок колонны.Участок/Тип документа",
      width: "w-full",
    },
  ]);
  const dependencies: any = useAppSelector((state) =>
    selectItems(state, dependenciesListName)
  );
  const dependenciesStatus: any = useAppSelector((state) =>
    selectGetStatus(state, dependenciesListName)
  );
  const types: any = useAppSelector((state) =>
    selectItems(state, typesListName)
  );
  const sectors: any = useAppSelector((state) =>
    selectItems(state, sectorsListName)
  );
  const processes: any = useAppSelector((state) =>
    selectItems(state, processesListName)
  );
  const departments: any = useAppSelector((state) =>
    selectItems(state, departmentsListName)
  );
  const collections: any = useAppSelector((state) =>
    selectItems(state, collectionsListName)
  );
  const lines: any = useAppSelector((state) =>
    selectItems(state, linesListName)
  );
  const workplaces: any = useAppSelector((state) =>
    selectItems(state, MDWorkstationListName)
  );
  const dispatch = useAppDispatch();
  const currentUser: any = useAppSelector(selectCurrentUser);

  //Оперделение дефолтных выпадающих списков в форме документа
  useEffect(() => {
    if (currentUser.id) {
      const tempFieldsForm = [...fieldsForm];
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "DocType") {
          tempFieldsForm[i]["options"] = types.map((type: any) => {
            return {
              id: type.ID,
              name: type.Title,
            };
          });
        }
        if (tempFieldsForm[i]["key"] === "Collection") {
          const options = collections.filter((collection: any) => {
            if (
              currentUser.isAdmin ||
              (currentUser.isCollectionAdmin &&
                currentUser.isCollectionAdmin.length > 0 &&
                currentUser.isCollectionAdmin.find(
                  (collectionID: any) => collectionID === collection.ID
                )) ||
              (currentUser.isCollectionEditor &&
                currentUser.isCollectionEditor.length > 0 &&
                currentUser.isCollectionEditor.find(
                  (collectionID: any) => collectionID === collection.ID
                ))
            ) {
              return true
            } else {
              return false
            }
          }).map((collection: any) => {
            return {
              id: collection.ID,
              name: collection.Title,
              available: true,
            };
          });
          tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
        }
        if (tempFieldsForm[i]["key"] === "Critical") {
          tempFieldsForm[i]["options"] = [
            {
              id: 1,
              name: "Критичный",
            },
            {
              id: 0,
              name: "Не критичный",
            },
          ];
        }
      }
      setFieldsForm([...tempFieldsForm]);
    }
  }, [types, collections, currentUser]);

  useEffect(() => {
    const tempFieldsForm = [...fieldsForm];
    if (dependenceFields["Collection"]) {
      dispatch(
        getItems({
          listName: dependenciesListName,
          filters: { Collection: dependenceFields["Collection"]["id"] },
          sortOrder: { name: "SortDepend", asc: true },
        })
      );
    }
    if (dependenceFields["Collection"] && dependenceFields["Department"]) {
      dispatch(
        getItems({
          listName: MDWorkstationListName
        })
      );
    }
    setCode(
      `${(dependenceFields["Collection"] &&
        collections.length > 0 &&
        collections.filter(
          (collection: any) =>
            collection.ID === dependenceFields["Collection"]["id"]
        ).length > 0 &&
        collections.filter(
          (collection: any) =>
            collection.ID === dependenceFields["Collection"]["id"]
        )[0]["Code"]) ||
      "__"
      }.${(dependenceFields["Department"] &&
        departments.length > 0 &&
        departments.filter(
          (department: any) =>
            department.ID === dependenceFields["Department"]["id"]
        ).length > 0 &&
        departments.filter(
          (department: any) =>
            department.ID === dependenceFields["Department"]["id"]
        )[0]["Code"]) ||
      "__"
      }.${(dependenceFields["Sector"] &&
        sectors.length > 0 &&
        sectors.filter(
          (sector: any) => sector.ID === dependenceFields["Sector"]["id"]
        ).length > 0 &&
        sectors.filter(
          (sector: any) => sector.ID === dependenceFields["Sector"]["id"]
        )[0]["Code"]) ||
      "__"
      }.${(dependenceFields["Process"] &&
        processes.length > 0 &&
        processes.filter(
          (process: any) => process.ID === dependenceFields["Process"]["id"]
        ).length > 0 &&
        processes.filter(
          (process: any) => process.ID === dependenceFields["Process"]["id"]
        )[0]["Code"]) ||
      "__"
      }.${(dependenceFields["Type"] && dependenceFields["Type"]["name"]) || "__"
      }`
    );

    if (!dependenceFields["Collection"]) {
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (
          tempFieldsForm[i]["key"] === "Department" ||
          tempFieldsForm[i]["key"] === "Sector" ||
          tempFieldsForm[i]["key"] === "Process" ||
          tempFieldsForm[i]["key"] === "WorkPlaces"
        ) {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
    }
    if (dependenceFields["Collection"]) {
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "WorkPlaces") {
          tempFieldsForm[i]["disabled"] = false;
        }
        if (
          tempFieldsForm[i]["key"] === "Sector" ||
          tempFieldsForm[i]["key"] === "Process"
        ) {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
    }
    if (dependenceFields["Department"]) {
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Sector") {
          tempFieldsForm[i]["disabled"] = false;
        }
        if (tempFieldsForm[i]["key"] === "Process") {
          tempFieldsForm[i]["disabled"] = true;
        }
      }
    }
    if (dependenceFields["Sector"]) {
      for (let i = 0; i < tempFieldsForm.length; i++) {
        if (tempFieldsForm[i]["key"] === "Process") {
          tempFieldsForm[i]["disabled"] = false;
        }
      }
    }
    setIndexDocument("");
    setIndexDocumentNumber(null);
    setFieldsForm([...tempFieldsForm]);
  }, [dependenceFields]);

  useEffect(() => {
    const tempFieldsForm = [...fieldsForm];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      if (dependenceFields["Collection"]) {
        if (tempFieldsForm[i]["key"] === "Department") {
          const options = dependencies
            .filter(
              (dependence: any) =>
                dependence.Collection.ID ===
                dependenceFields["Collection"]["id"]
            )
            .map((dependence: any) => {
              return {
                id: dependence.Department.ID,
                name: dependence.Department.Title,
              };
            });
          tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
        }
        if (tempFieldsForm[i]["key"] === equipmentsListName) {
          tempFieldsForm[i]["fields"]?.map((field) => {
            if (field["key"] === "Line") {
              const options = lines
                .filter(
                  (line: any) =>
                    line.Collection.ID === dependenceFields["Collection"]["id"]
                )
                .map((line: any) => {
                  return {
                    id: line.ID,
                    name: line.Title,
                  };
                });
              field["options"] = _.uniqWith(options, _.isEqual);
            }
            if (field["key"] === "SAP") {
              field["searchApiFilterField"] = "Collection";
              field["searchApiFilterFieldValue"] =
                dependenceFields["Collection"]["name"];
            }
          });
        }
      }
      if (dependenceFields["Department"]) {
        if (tempFieldsForm[i]["key"] === "Sector") {
          const options = dependencies
            .filter(
              (dependence: any) =>
                dependence.Department.ID ===
                dependenceFields["Department"]["id"]
            )
            .map((dependence: any) => {
              return {
                id: dependence.Sector.ID,
                name: dependence.Sector.Title,
              };
            });
          tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
        }
      }
      if (dependenceFields["Sector"]) {
        if (tempFieldsForm[i]["key"] === "Process") {
          const options = dependencies
            .filter(
              (dependence: any) =>
                dependence.Sector.ID === dependenceFields["Sector"]["id"] &&
                dependence.Department.ID ===
                dependenceFields["Department"]["id"]
            )
            .map((dependence: any) => {
              return {
                id: dependence.Process.ID,
                name: dependence.Process.Title,
              };
            });
          tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
        }
      }
      if (dependenceFields["Collection"] && tempFieldsForm[i]["key"] === "WorkPlaces") {
        const options =
          (workplaces.length > 0 &&
            workplaces.map((place: any) => {
              return {
                id: place.ID,
                name: `${place.Location.Title}_${place.Workstation}`,
              };
            }).filter((place: any) => place.name.indexOf(dependenceFields["Collection"]['name']) !== -1).sort((a, b) => a.name.localeCompare(b.name, 'ru', { sensitivity: 'base' }))) ||
          [];
        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
      }
    }
    setFieldsForm([...tempFieldsForm]);
  }, [dependencies, dependenciesStatus, workplaces]);

  useEffect(() => {
    if (indexDocument) {
      setCode(`${code}.${indexDocument}`);
    }
  }, [indexDocument]);

  //Определяем индекс документа
  useEffect(() => {
    if (code.indexOf("__") === -1 && !indexDocument) {
      const codeArr = code.split(".");
      let codeRequest = "";
      if (codeArr.length === 6) {
        codeArr.forEach((item: string, idx: number) => {
          if (idx <= 3) {
            codeRequest += `${item}.`;
          }
          if (idx === 4) {
            codeRequest += `${item}`;
          }
        });
      } else {
        codeRequest = code;
      }
      getItemsRequest({
        listName: documentCodeIndexesListName,
        filters: { Title: codeRequest },
        rowLimit: 1,
        sortOrder: { name: "Index", desc: true },
      }).then((results) => {
        if (results.items.length === 0) {
          let ans = ("0000" + String(results.items.length + 1)).substring(
            String(results.items.length + 1).length
          );
          setIndexDocumentNumber(results.items.length + 1);
          setIndexDocument(ans);
        } else {
          let ans = ("0000" + String(results.items[0]["Index"] + 1)).substring(
            String(results.items[0]["Index"] + 1).length
          );
          setIndexDocumentNumber(results.items[0]["Index"] + 1);
          setIndexDocument(ans);
        }
      });
    }
  }, [code]);

  return (
    <div className="step_2 md:min-w-[975px]">
      <span className="text-7.5 leading-[38px] font-bold text-black block mb-8">
        Карточка документа
      </span>
      <span className="text-[16px] leading-[22px] font-medium text-black block mb-5">
        Загрузите заполненный шаблон документа
      </span>
      <Form
        code={code}
        setDependenceFields={setDependenceFields}
        type="add_card"
        openCancelAddCard={openCancelAddCard}
        setOpenCancelAddCard={setOpenCancelAddCard}
        setFormData={setFormData}
        fieldsForm={fieldsForm}
        defaultValues={defaultValues}
      />
    </div>
  );
}

export default Step_2;
